import styles from './ChipList.module.scss';

export const ChipList = ({ children }) => (
  <div className={styles['chip-list']}>{children}</div>
);
